import { NavLink, useLocation } from "react-router-dom";
import { Button, Paper } from "@mui/material";
import UserMenu from "./UserMenu";
// hooks
import useResponsive from "src/hooks/useResponsive";
import useAppContext from "src/hooks/useAppContext";
import { NAVBAR_WIDTH } from "./constants";

export default function AppBar() {
  const { user } = useAppContext();
  const { pathname } = useLocation();
  
  const isDesktop = useResponsive('up', 'lg');

  return (
    <Paper
      sx={{
        p: 1,
        top: 0,
        position: 'sticky',
        ...isDesktop && {
          ml: `${NAVBAR_WIDTH}px`
        },
        display: "flex",
        flexDirection: "row",
        justifyContent: 'right',
        zIndex: 100
      }}
    >
      {user ?
        <UserMenu />
        :
        (user !== undefined && pathname !== '/auth' && pathname !== '/login' &&
          <Button
            variant="outlined"
            component={NavLink}
            to='/login'
          >
            Fazer login
          </Button>
        )
      }
    </Paper>
  )
}